import Checkbox from './Checkbox';
import Text from './Text';
import Select from './Select';
import Radio from './Radio';
import Color from './Color';
import NumberControl from './NumberControl';

const controls = {
    'text' : Text,
    'checkbox' : Checkbox,
    'select' : Select,
    'number' : NumberControl,
    'radio' : Radio,
    'color' : Color
}

export default controls